import React, { useState } from 'react';

// ── Iron rule (owner, download-button-spinner): every slow export/download button spins and
// disables the moment it is clicked — no dead-looking buttons, no double downloads. Drop-in
// replacement for a <button onClick={() => api.x().catch(alert)}>: pass the promise via onRun.
export default function DlBtn({ onRun, style, title, disabled, children }: {
  onRun: () => Promise<any>; style?: React.CSSProperties; title?: string; disabled?: boolean; children: React.ReactNode;
}) {
  const [busy, setBusy] = useState(false);
  return (
    <button title={title} disabled={disabled || busy}
      style={{ ...(style || {}), ...(busy ? { opacity: 0.55, cursor: 'wait' } : {}) }}
      onClick={() => {
        if (busy) return;
        setBusy(true);
        onRun().catch((e: any) => alert(e?.message || 'Download failed')).finally(() => setBusy(false));
      }}>
      {busy ? <i className="ti ti-loader" /> : children}
    </button>
  );
}
